class Results {

    constructor() {
        if (Results.instance) return Results.instance;
        this.container = document.getElementById('team-filter-response');

        if(this.container) {
            document.addEventListener('employeesFetched', (data) => {
                // Run results a little later (always after the spinner)
                setTimeout(() => {
                    this.showResults(data.detail);
                }, 250);
            });
            document.addEventListener('filterInputChange', () => {
                this.addLoadingSpinner();
            });
        }

        Results.instance = this;
    }

    addLoadingSpinner() {
        this.container.innerHTML = '<div id="loadingSpinner"><div></div></div>';
    }

    showResults(data) {
        const currentCategory = data.categoryId;
        const response = data.apiResponse;

        this.container.innerHTML = '';

        const dataContainer = document.createElement('div');
        dataContainer.classList.add('results');

        if(response.length <= 0) {
            dataContainer.innerHTML = 'Keine Ansprechpartner gefunden - bitte kontaktieren Sie den Betreiber der Webseite.';
            this.container.appendChild(dataContainer);
            return;
        }

        response.forEach((employee) => {
            const card = document.createElement('div');
            card.classList.add('employee-card');
            let position = employee.position;
            let email = employee.email;
            let phone = employee.phone;
            let customNote = employee.customNote;

            if(employee.additionalPositions[currentCategory] !== undefined) {
                position = employee.additionalPositions[currentCategory];
            }

            /* eslint-disable indent */
            card.innerHTML = `
                <img alt="Mitarbeiterfoto ${employee.name}" src="${employee.thumbnail}" />
                <div id="title">${employee.name}</div>
                <div id="details">
                    ${position && position?.length > 0 ?
                        `<div id="position">${position || ''}</div>`
                    : ''}
                    ${customNote && customNote?.length > 0 ?
                        `<div id="custom-note">${customNote || ''}</div>`
                    : ''}
                    ${phone && phone?.length > 0 ?
                        `<div id="phone">${phone || ''}</div>`
                    : ''}
                    ${email && email?.length > 0 ?
                        `<a id="email" href="mailto:${email}">E-Mail schreiben</a>`
                    : ''}
                </div>
            `;
            /* eslint-enable indent */

            dataContainer.appendChild(card);
        });

        this.container.appendChild(dataContainer);
    }
}

export default Results;
